import React from 'react';

export default function ErrorScreen({ onRetry }) {
  return (
    <div className="view on" data-testid="error-screen">
      <div className="gateway-center">
        <h1 data-content="error.generic_title">Something went wrong</h1>
        <p className="desc" data-content="error.network_message">
          Unable to connect. Please check your internet connection and try again.
        </p>
        <button className="btn btn-p" onClick={onRetry} data-testid="retry-btn">Try Again</button>
      </div>
    </div>
  );
}
